import { useTheme } from '../context/ThemeContext';
import { useFontSize } from '../context/FontSizeProvider';

/**
 * Custom hook to centralize all accessibility controls.
 * This provides a single entry point for theme and font size management.
 */
export function useAccessibility() {
    const { theme, toggleTheme, isDark, isHighContrast, toggleHighContrast } = useTheme();
    const {
        fontLevel,
        increaseFontSize,
        decreaseFontSize,
        resetFontSize,
        canIncrease,
        canDecrease
    } = useFontSize();

    return {
        // Theme
        theme,
        isDark,
        toggleTheme,

        // High Contrast
        isHighContrast,
        toggleHighContrast,

        // Font Size
        fontLevel,
        increaseFontSize,
        decreaseFontSize,
        resetFontSize,
        canIncrease,
        canDecrease,

        // Helpers
        fontScale: fontLevel === 0 ? '100%' : `${100 + fontLevel * 12.5}%`
    };
}
